const FETCHING_AGENT = "@agent/fetchingAgent";
const FETCHING_AGENT_ERROR = "@agent/fetchingAgentError";
const FETCHING_AGENT_SUCCESS = "@agent/fetchingAgentSuccess";

const SEARCH_AGENT = "@agent/searchAgent";
const SEARCH_AGENT_ERROR = "@agent/searchAgentError";
const SEARCH_AGENT_SUCCESS = "@agent/searchAgentSuccess";

const ADD_AGENT = "@agent/addAgent";
const ADD_AGENT_ERROR = "@agent/addAgentError";
const ADD_AGENT_SUCCESS = "@agent/addAgentSuccess";

const DELETE_AGENT = "@agent/deleteAgent";
const DELETE_AGENT_ERROR = "@agent/deleteAgentError";
const DELETE_AGENT_SUCCESS = "@agent/deleteAgentSuccess";

const CLEAR_SEARCH = "@agent/clearSearch";

const CLEAR_STORE = "@agent/clearStore";

export {
  FETCHING_AGENT,
  FETCHING_AGENT_SUCCESS,
  FETCHING_AGENT_ERROR,
  CLEAR_STORE,
  SEARCH_AGENT,
  SEARCH_AGENT_SUCCESS,
  SEARCH_AGENT_ERROR,
  CLEAR_SEARCH,
  ADD_AGENT,
  ADD_AGENT_ERROR,
  ADD_AGENT_SUCCESS,
  DELETE_AGENT,
  DELETE_AGENT_ERROR,
  DELETE_AGENT_SUCCESS
};
